import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { channelNavigateTo, isDouyinAppChannel, getUserOpenIdForTiktok } from '@/channels';
import { HOME, ORDER_PAY } from '@/constants/path';
import isEmpty from 'lodash/isEmpty';

const useNavigateToOrderPay = () => {
  const navigate = useNavigate();
  const [cookie] = useCookies(['sid']);

  /**
   * couponGroup: for douyin 产品与优惠券关联
   */
  return ({ orderId = '', payId = '', autopay = true, pIdCouponGroup = {}, oldPIdCouponGroup = {} }) => {
    if (isDouyinAppChannel()) {
      const _sid = typeof cookie.sid === 'string' ? cookie.sid : '';
      // for nav-back
      navigate(`${HOME}`, { replace: true });
      channelNavigateTo(
        `/pages/order/detail?orderId=${orderId}&payId=${payId}&sid=${_sid}&openid=${getUserOpenIdForTiktok() ?? ''}${
          autopay ? '&autopay=1' : ''
        }${!isEmpty(pIdCouponGroup) ? '&couponGroup2=' + encodeURIComponent(JSON.stringify(pIdCouponGroup)) : ''}${
          !isEmpty(oldPIdCouponGroup) ? '&couponGroup=' + encodeURIComponent(JSON.stringify(oldPIdCouponGroup)) : ''
        }`,
        { redirect: false },
      );
    } else {
      navigate(`${ORDER_PAY}?orderId=${orderId}&payId=${payId}&source=0`, { replace: true });
    }
  };
};

export default useNavigateToOrderPay;
